import React from "react";

const UpperHeader = () => {
  return <div className='upperHeader-container'></div>;
};

export default UpperHeader;
